var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3636 7C13.3636 8.75727 11.9391 10.1818 10.1818 10.1818C8.42455 10.1818 7 8.75727 7 7C7 5.24273 8.42455 3.81818 10.1818 3.81818C11.9391 3.81818 13.3636 5.24273 13.3636 7Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 7 3.81818 0 10.1818 0C16.5455 0 20.3636 7 20.3636 7C20.3636 7 16.5455 14 10.1818 14C3.81818 14 0 7 0 7ZM10.1818 11.4545C12.642 11.4545 14.6364 9.46018 14.6364 7C14.6364 4.53982 12.642 2.54545 10.1818 2.54545C7.72164 2.54545 5.72727 4.53982 5.72727 7C5.72727 9.46018 7.72164 11.4545 10.1818 11.4545Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEye);
export default __webpack_public_path__ + "static/media/ico-eye.7f3a8ebb9d7927fd83067e3b536ef27d.svg";
export { ForwardRef as ReactComponent };